module.exports = __webpack_public_path__ + "img/middlecontrol.795b29a4.svg";